import { TDailyScheduleEntry } from "../types";
import DayItemEntry from "./DayItemEntry";
import { styled, useStyletron } from "baseui";
import { TScheduler } from "../types";
import { useEffect, useRef, useState } from "react";

const DayItem: React.FC<{
  items: TDailyScheduleEntry[],
  dayOfWeek: number,
  app: TScheduler,
  now: Date,
  onEntryDeleted: (weekday: number, event: TDailyScheduleEntry) => void,
  onEntryChanged: (weekday: number, event: TDailyScheduleEntry) => void
}> = (props) => {
  const [css,theme] = useStyletron()
  const isEmpty = props.items.length === 0;
  const items = isEmpty ? [] : props.items;
  const ref = useRef<any>(null)
  const [height, setHeight] = useState(0)
  
  useEffect(() => {
      setHeight(ref.current?.clientHeight ?? 0)
  },[])

  const handleItemChanged = (item: TDailyScheduleEntry) => { props.onEntryChanged(props.dayOfWeek,item) }
  const handleItemDeleted = (item: TDailyScheduleEntry) => { props.onEntryDeleted(props.dayOfWeek,item) }

  return (<ItemsContainer ref={ref} $width={'100%'}>
    {items.map((v, i) =>
      <>
        <DayItemEntry totalHeight={height - items.length * 5} isFirst={i === 0 } isLast={i+1 === items.length} onEventChanged={handleItemChanged} onEventDeleted={handleItemDeleted} now={props.now} app={props.app} item={v}></DayItemEntry>

      </>
    )}
  </ItemsContainer>);
};

export default DayItem;

const ItemsContainer = styled<'div', { $width }>("div", ({ $theme, $width }) => ({
  display: 'grid',
  width: $width ?? '100%',
  //height: '500px',
  rowGap: '5px',
  columnGap: $theme.sizing.scale200,
  gridTemplateColumns: '50px 1fr',
  alignItems: 'flex-start',
  height: '500px'
}));








